"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.user = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const user = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'user-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M3.25 14C3.25 11.3766 5.37665 9.25 8 9.25H12C14.6234 9.25 16.75 11.3766 16.75 14V17C16.75 17.4142 16.4142 17.75 16 17.75H4C3.58579 17.75 3.25 17.4142 3.25 17V14ZM8 10.75C6.20507 10.75 4.75 12.2051 4.75 14V16.25H15.25V14C15.25 12.2051 13.7949 10.75 12 10.75H8Z', fill: '#4B5563' }),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M6.25 5C6.25 2.92893 7.92893 1.25 10 1.25C12.0711 1.25 13.75 2.92893 13.75 5V6C13.75 8.07107 12.0711 9.75 10 9.75C7.92893 9.75 6.25 8.07107 6.25 6V5ZM10 2.75C8.75736 2.75 7.75 3.75736 7.75 5V6C7.75 7.24264 8.75736 8.25 10 8.25C11.2426 8.25 12.25 7.24264 12.25 6V5C12.25 3.75736 11.2426 2.75 10 2.75Z', fill: '#4B5563' })));
};
exports.user = user;
